<template>
	<!-- Navbar -->
	<b-navbar toggleable="lg" type="light" class="bg-white">
		<b-container>

			<!-- Navbar Icon -->
			<b-navbar-brand href="/" aria-label="Home">
				<svg title="Logo" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
					xmlns:a="http://ns.adobe.com/AdobeSVGViewerExtensions/3.0/" x="0px" y="0px" width="129.7px"
					height="22px" viewBox="0 0 129.7 22" style="enable-background:new 0 0 129.7 22;" xml:space="preserve" itemprop="logo">
					<defs>
					</defs>
					<g>
						<path style="fill: #414042;" d="M9.1,13.9l0,3.4c0,2.6-1.3,3.9-3.9,3.9H3.8c-2.6,0-3.8-1.3-3.8-3.8L0,13l3.1,0l0,4.3c0,0.8,0.4,1.2,1.2,1.2
		l0.4,0C5.6,18.4,6,18,6,17.2v-2.9c0-0.9-0.3-1.2-0.9-1.7l-3.2-2.4C0.4,9.3,0,8.3,0,6.7V3.9C0,1.3,1.3,0,3.9,0h1.3
		c2.6,0,3.8,1.3,3.8,3.8v3.8l-3.1,0l0-3.7c0-0.8-0.4-1.2-1.2-1.2H4.3C3.5,2.8,3.2,3.2,3.2,4l0,2.3C3.2,7.1,3.5,7.6,4,8l3.2,2.4
		C8.7,11.3,9.1,12.2,9.1,13.9z" />
						<path style="fill: #414042;" d="M20.1,12.5l0,4.9c0,2.6-1.3,3.9-3.9,3.9l-1.6,0c-2.6,0-3.9-1.3-3.9-3.9l0-13.5c0-2.6,1.3-3.9,3.9-3.9h1.5
		C18.8,0,20,1.3,20,3.8v4.3h-3.1V4c0-0.8-0.4-1.2-1.2-1.2h-0.5C14.3,2.8,14,3.2,14,4l0,13.2c0,0.8,0.4,1.2,1.2,1.2h0.6
		c0.8,0,1.2-0.4,1.2-1.2v-4.7L20.1,12.5z" />
						<path style="fill: #414042;" d="M31.1,17.3c0,2.6-1.3,3.9-3.9,3.9l-1.5,0c-2.6,0-3.9-1.3-3.9-3.9l0-17.1H25l0,17c0,0.8,0.4,1.2,1.2,1.2l0.5,0
		c0.8,0,1.2-0.4,1.2-1.2v-17h3.2V17.3z" />
						<path style="fill: #414042;" d="M36.2,0.2v18h3.5V21H33V0.2H36.2z" />
						<path style="fill: #414042;" d="M44.4,21h-3.2V0.2h5C48.8,0.2,50,1.5,50,4v5.5c0,2.6-1.3,3.9-3.9,3.9h-1.8V21z M45.7,3h-1.3v7.7h1.3
		c0.8,0,1.2-0.4,1.2-1.2V4.2C46.9,3.4,46.5,3,45.7,3z" />
						<path style="fill: #414042;" d="M53.6,21v-18h-2.9V0.2h8.9v2.9h-2.9v18H53.6z" />
						<path style="fill: #414042;" d="M59.8,4.7h3v1.1c0.8-0.7,1.6-1.3,2.9-1.3h0.1c1.7,0,2.6,1,2.6,2.8V21h-3V8.2c0-0.7-0.3-1-1-1
		c-0.6,0-1,0.2-1.6,0.5V21h-3V4.7z" />
						<path style="fill: #414042;" d="M70,15.1c0-1.9,0.6-2.7,2.3-3.3l3.1-1.1V8.2c0-0.7-0.4-1.1-1.1-1.1h-0.2c-0.7,0-1.1,0.4-1.1,1.1v2h-2.8V8.1
		c0-2.4,1.2-3.6,3.6-3.6h1c2.4,0,3.6,1.2,3.6,3.6V21h-3v-1c-0.7,0.7-1.5,1.2-2.8,1.2h0c-1.7,0-2.6-1-2.6-2.8V15.1z M75.4,18v-4.7
		l-1.6,0.6c-0.7,0.3-0.9,0.6-0.9,1.3v2.3c0,0.6,0.3,0.9,1,0.9C74.4,18.5,74.9,18.3,75.4,18z" />
						<path style="fill: #414042;" d="M83.6,21h-3V7.3h-1.1V4.7h1.1V2h3v2.7h1.6v2.6h-1.6V21z" />
						<path style="fill: #414042;" d="M86.3,0.4h3.1v2.9h-3.1V0.4z M86.4,4.7h3V21h-3V4.7z" />
						<path style="fill: #414042;" d="M94.8,21.2c-2.4,0-3.6-1.2-3.6-3.6V8.1c0-2.4,1.2-3.6,3.6-3.6h1.4c2.4,0,3.6,1.2,3.6,3.6v9.4
		c0,2.4-1.2,3.6-3.6,3.6H94.8z M95.2,7.2c-0.7,0-1.1,0.4-1.1,1.1v9.1c0,0.7,0.4,1.1,1.1,1.1h0.5c0.7,0,1.1-0.4,1.1-1.1V8.3
		c0-0.7-0.4-1.1-1.1-1.1H95.2z" />
						<path style="fill: #414042;" d="M101.5,4.7h3v1.1c0.8-0.7,1.6-1.3,2.9-1.3h0.1c1.7,0,2.6,1,2.6,2.8V21h-3V8.2c0-0.7-0.3-1-1-1
		c-0.6,0-1,0.2-1.6,0.5l0,13.3h-3L101.5,4.7z" />
					</g>
					<g id="XMLID_1_">
						<g id="XMLID_6_">
							<path style="fill: #ED1C24;"
								d="M113.1,9.8c0-1.2,0.7-1.5,1.5-0.6l4.5,4.6c0.8,0.8,0.8,2.2,0,3.1l-4.5,4.6c-0.8,0.8-1.5,0.6-1.5-0.6V9.8z" />
						</g>
						<g id="XMLID_3_">
							<path style="fill: #ED1C24;" d="M117.1,20.4c-0.8,0.8-0.5,1.5,0.6,1.5h3.8c1.2,0,2.8-0.7,3.7-1.5l3.9-3.9c0.8-0.8,0.8-2.2,0-3.1l-7.6-7.6
			c-0.8-0.8-2.5-1.5-3.7-1.5h-4.1c-1.2,0-1.5,0.7-0.6,1.5l7.7,7.7c0.8,0.8,0.8,2.2,0,3.1L117.1,20.4z" />
						</g>
					</g>
				</svg>
			</b-navbar-brand>

			<!-- Navbar mobile button -->
			<b-navbar-toggle target="nav-collapse" />

			<!-- Nav links -->
			<b-collapse id="nav-collapse" is-nav>

				<b-navbar-nav class="ml-auto">
					<!-- Home -->
					<b-nav-item href="/" class="text-uppercase" :class="{ 'active': exactPath('/') }"
						aria-label="Home">Home</b-nav-item>

					<!-- Shop -->
					<b-nav-item href="/products" class="text-uppercase"
						:class="{ 'active': pathStarts('/products') }">Supplements</b-nav-item>

					<!-- Product Guide -->
					<b-nav-item-dropdown text="Supplement Guide" class="text-uppercase"
						:class="{ 'active': pathStarts('/supplement-guide-for') }">
						<b-dropdown-item href="/supplement-guide-for-women">Female Guide</b-dropdown-item>
						<b-dropdown-item href="/supplement-guide-for-men">Male Guide</b-dropdown-item>
					</b-nav-item-dropdown>

					<!-- Clothing -->
					<b-nav-item href="https://clothing.vshred.com" class="text-uppercase">Clothing</b-nav-item>

					<!-- About Us -->
					<b-nav-item href="/about-us" class="text-uppercase" :class="{ 'active': pathStarts('/about-us') }">About
						Us</b-nav-item>

					<!-- My Account -->
					<b-nav-item href="/my-account" class="text-uppercase"
						:class="{ 'active': pathStarts('/my-account') }">My Account</b-nav-item>

					<!-- Reviews -->
					<b-nav-item href="/reviews" class="text-uppercase"
						:class="{ 'active': pathStarts('/reviews') }">Reviews</b-nav-item>

					<!-- Cart -->
					<b-nav-item href="/cart" class="pl-lg-3">
						<span class="text-uppercase text-danger ">
							<i class="fas fa-shopping-cart"></i>
							<span>{{ itemCount }} {{ itemCount === 1 ? 'item' : 'items' }}</span>
						</span>
					</b-nav-item>

				</b-navbar-nav>

			</b-collapse>

		</b-container>
	</b-navbar>
</template>

<script>

import api from '@js/api';
import service from '@js/service/cartService';

export default {
	computed: {
		itemCount() {
			let cart = this.$store.getters['cart/getCart'];
			return cart ? cart.product_count : 0;
		}
	},

	async beforeMount() {
		await service.subscribe('getCart');
	},

	methods: {
		exactPath(path) {
			return window.location.pathname === path;
		},

		pathStarts(path) {
			return window.location.pathname.startsWith(path);
		}
	}
}

</script>
